import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Box, Grid, Typography } from '@mui/material';
import type { Owner } from '../../../../../../types';
import { TranslationKeys } from '../../../../../../translations';
import { ActionLink } from '../../../../../../components';
import { Pagination } from '../../../../../../components/Pagination';
import { GridStyled } from './OwnerSubOwners.styles';

type OwnerSubOwnersProps = {
  subOwners: Owner[];
  page: number;
  pageSize: number;
  totalCount: number;
  pageSizeOptions: number[];
  onPaginationChange: (args: { page?: number; rowSize?: number }) => void;
};

export const OwnerSubOwners = ({
  subOwners,
  page,
  pageSize,
  totalCount,
  pageSizeOptions,
  onPaginationChange,
}: OwnerSubOwnersProps) => {
  if (totalCount === 0) {
    return (
      <Grid sx={{ width: '100%' }} container spacing={2}>
        <Grid item xs={12}>
          <Typography>
            <FormattedMessage id={TranslationKeys.global_noData} />
          </Typography>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid sx={{ width: '100%' }} container spacing={2}>
      {!!subOwners?.length &&
        subOwners.map(subOwner => (
          <GridStyled item key={subOwner.ownerId} xs={12}>
            <Grid container>
              <Grid item xs={7}>
                <Typography variant="body1">{subOwner.ownerName}</Typography>
              </Grid>

              <Grid item xs={5}>
                <Box textAlign="right">
                  <ActionLink to={`/sub-owners/${subOwner.ownerId}`}>
                    <Typography variant="body1">
                      <FormattedMessage id={TranslationKeys.owners_showDetailPage} />
                    </Typography>
                  </ActionLink>
                </Box>
              </Grid>
            </Grid>
          </GridStyled>
        ))}
      <Grid item xs={12}>
        <Pagination
          count={totalCount}
          page={page}
          rowsPerPage={pageSize}
          rowsPerPageOptions={pageSizeOptions}
          onPaginationChange={onPaginationChange}
        />
      </Grid>
    </Grid>
  );
};
